import styled from 'styled-components';

/** Matches cosafe-app multi-org-active-banner palette. */
const goldBg = 'rgba(255, 190, 0, 0.07)';
const goldBorder = 'rgba(255, 190, 0, 0.22)';

/** Sidebar-only outer shell — no padding so the parent controls spacing. */
export const SOuter = styled.div`
  box-sizing: border-box;
`;

export const SCard = styled.div`
  background-color: ${goldBg};
  border: 1px solid ${goldBorder};
  border-radius: 11px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  box-sizing: border-box;
`;

export const STitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.palette.text.accent};
  font-family: 'Roboto-Bold', 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 10px;
  letter-spacing: 1px;
  text-transform: uppercase;
  line-height: 1.2;
`;

export const STenantName = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.palette.text.primary};
  font-family: 'Roboto-Medium', 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.3;
`;

export const SEmail = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.palette.text.inputPrimary};
  font-family: 'Roboto-Regular', 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
`;
